import { Divider } from '@byecode/ui'
import React, { useState } from 'react'
import { Controller } from 'react-hook-form'

import { getBlockAndPageDesignLimit, PositionSetting } from '@/components/StyleSetting'
import AnimationSetting from '@/components/StyleSetting/AnimationSetting'
import { SizeSetting } from '@/components/StyleSetting/SizeSetting'
import { VisibilitySetting } from '@/components/VisibilitySetting'

import { BlockConfigureSegmentedControl } from '../Common/BlockConfigureSegmentedControl'
import { CursorSetting } from '../Common/CursorSetting'
import type { BlockSettingsSegmentedEnum } from '../constants'
import { BLOCK_SETTINGS_SEGMENTED_ENUM } from '../constants'

interface BreadcrumbSettingProps {}

export const BreadcrumbSetting: React.FC<BreadcrumbSettingProps> = () => {
    const [currentTab, setCurrentTab] = useState<BlockSettingsSegmentedEnum>(BLOCK_SETTINGS_SEGMENTED_ENUM.DESIGN)
    const styleProps = getBlockAndPageDesignLimit('breadcrumb')
    return (
        <>
            <BlockConfigureSegmentedControl isInterAction value={currentTab} onChange={setCurrentTab} />
            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.DESIGN && (
                <>
                    <PositionSetting {...styleProps.position} />
                    <Divider />
                    <SizeSetting {...styleProps.size} />
                    <Divider />
                    <Controller name="cursor" render={({ field }) => <CursorSetting {...field} />} />
                </>
            )}

            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.CONFIGURE && <VisibilitySetting />}

            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.INTERACTION && <AnimationSetting />}
        </>
    )
}
